import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useGameBoxGameUrl = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const gameBoxGameUrlKeyString = 'setGameUrl=';
    const startIndex = search.indexOf(gameBoxGameUrlKeyString);

    if (startIndex === -1) {
      return ''; // return an empty string if the key is not found
    }

    return search.slice(startIndex + gameBoxGameUrlKeyString.length); // Remove the key and get the URL
  }, [search]);
};